/**
 * Line clamp + read more for .text-block--line-clamp (see snippets/text.liquid).
 */
(function () {
  'use strict';

  /**
   * @param {Element} root
   */
  function updateClampButton(root) {
    if (!root.classList.contains('text-block--line-clamp')) return;
    const inner = root.querySelector('.text-block__clamp-inner');
    const btn = root.querySelector('.text-block__read-more');
    if (!inner || !btn) return;

    if (root.classList.contains('text-block--line-clamp-expanded')) {
      btn.hidden = false;
      return;
    }

    void inner.offsetHeight;
    const overflow = inner.scrollHeight > inner.clientHeight + 2;
    btn.hidden = !overflow;
  }

  function initAll() {
    document.querySelectorAll('.text-block--line-clamp').forEach(updateClampButton);
  }

  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  });

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.text-block__read-more');
    if (!btn) return;
    const root = btn.closest('.text-block--line-clamp');
    if (!root) return;
    e.preventDefault();
    const expanded = root.classList.toggle('text-block--line-clamp-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    const more = btn.querySelector('.text-block__read-more-label--more');
    const less = btn.querySelector('.text-block__read-more-label--less');
    if (more) more.hidden = expanded;
    if (less) less.hidden = !expanded;
    if (expanded) {
      btn.hidden = false;
    } else {
      updateClampButton(root);
    }
  });
})();
